// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T1-J","question":"styles_question__3dHwr","description":"styles_description__27WZE"};